export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-bottom-bar/index.js